import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import AxisRecap from "../../../../Retrofit/components/Devices/AxisRecap";
import BillOfMaterials from "../../../../Retrofit/components/BillOfMaterials/BillOfMaterials";
import BillOfMaterialsMc12 from "../../../../Mc12/components/BillOfMaterials/BillOfMaterials";

import { selectConfigAxes } from "../../../../Retrofit/store/slices/retrofit";
import t from "../../../utils/translation/translator";
import { getCurrentConfiguration } from "../../../utils/api/common";
import { selectConfigurationType } from "../../../store/slices/common";
import { gatherMc12ProductsForBOM } from "../../../../Mc12/utils/func.utils";
import AxisComponent from "../../../../IntegratedDrives/components/ApplicationSettings/AxisComponent";
import { selectIntegratedDrivesAxes } from "../../../../IntegratedDrives/store/slices/integrated_drives";

const PrintPageContent = React.forwardRef((props, ref) => {
  const configurationAxes = useSelector(selectConfigAxes);
  const configuration = getCurrentConfiguration();
  const configurationType = useSelector(selectConfigurationType);
  // config link is current document url + config id
  const configLink = `${window.location.href}${window.location.search ? "&" : "?"}configuration=${
    configuration.configId
  }`;

  const intagratedDrivesAxes = useSelector(selectIntegratedDrivesAxes);

  return (
    <div ref={ref} className="PrintPageContent hidden px-5 mt-5 print:block print:visible" {...props}>
      <div className="print-headers mb-1">
        <div className="sub-header select-none flex p-3">
          <div className="flex-1">
            <img
              src="https://www.se.com/ww/en/assets/564/media/202250/SE_logo-LIO-white_header.svg"
              alt="logo"
              className="h-6"
            />
          </div>

          <div className="flex-1 flex justify-end items-center space-x-3 text-white text-xs">
            <span className="cursor-pointer">
              Creation date : {moment(configuration.createdDate).format("MMM DD, YYYY")}
            </span>
          </div>
        </div>

        <div className="bg-logoGreen text-white flex flex-col p-3">
          <span className="text-base font-bold">{configuration.configData.configName}</span>
          <span className="text-sm">
            <b>Configuration ID: </b>{" "}
            <a href={configLink} className="underline font-semibold">
              {configuration.configId}
            </a>
          </span>
        </div>
      </div>
      {configurationType === "RETROFIT" && (
        <div className="m-1 space-y-3">
          <span className="text-lg mb-3 font-bold text-gray-600">{t("msizer.ui.bill_of_materials")}</span>
          <BillOfMaterials defaultSortBy="Reference" />
          <span className="text-lg mb-3 font-bold text-gray-600">{t("msizer.ui.configuration_per_axis")}</span>
          <div className="space-y-2">
            {configurationAxes.map((axis, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <AxisRecap key={index} axis={axis} uncollapsed print />
            ))}
          </div>
        </div>
      )}
      {configurationType === "MC12" && (
        <div className="m-1 space-y-3">
          <span className="text-lg mb-3 font-bold text-gray-600">{t("msizer.ui.bill_of_materials")}</span>
          <BillOfMaterialsMc12 productsList={gatherMc12ProductsForBOM(configuration.configData.track)} />
        </div>
      )}
      {configurationType === "INTEGRATED_DRIVES" && (
        <div className="m-1 space-y-3">
          <span className="text-lg mb-3 font-bold text-gray-600">{t("msizer.ui.bill_of_materials")}</span>
          <BillOfMaterials defaultSortBy="Reference" />
          <span className="text-lg mb-3 font-bold text-gray-600">{t("msizer.ui.configuration_per_axis")}</span>
          <div className="space-y-4">
            {intagratedDrivesAxes?.map((axis) => (
              <AxisComponent
                key={axis.id}
                axisId={axis.id}
                axisName={axis.name}
                motorType={axis.motorType}
                bundle={axis.bundle}
                collapsed={true}
                storedSncWidgetOutput={axis.sncWidgetOutput}
                filters={axis.configFilters}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
});

export default PrintPageContent;
